
import { Component, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { Observable, of, pipe } from 'rxjs';
import { TaskDTO, DocumentDTO, getSimpleIdentifierFromString, getParentIdentifierFromString, RelatedDocumentDTO, MasterDataDTO } from '../../../api/plyca-dtos';
import { FormConfig } from '../../../components/forms/form.objects';
import { BaseFormComponent, BaseFormHeaderInfo } from '../../baseFormComponent/baseForm.component';
import { SettlementDTO } from '../model/settlement.model';
import { SettlementValidations } from './settlement.validation';
import { ContractDTO } from '../../../api/plyca-dtos-v2';
import { ReceiptDTO } from '../../receipt/model/receipt.model';
import { PaginationDTO } from '../../../api/PaginationModel';
import { ProjectOrganizationalSnapshotValidations } from '../../projectOrganizationalSnapshot/component/projectOrganizationalSnapshot.validation';
import { catchError } from 'rxjs/internal/operators/catchError';
import { finalize } from 'rxjs/internal/operators/finalize';


export class SettlementModel {
  dto: SettlementDTO;
  ui: {
    divisionId?: string,
    dossierId?: string,
    isREPLYCATask?: boolean,
    isProjectReplyca?: boolean,
    isPossibleAssociateReceipt?: boolean,
    edition?: boolean;
    isModeError?: boolean;
    existsRelatedReceipt?: boolean;
    relatedDocument?: DocumentDTO;
    originalRelatedReceipt?: ReceiptDTO;
    selectedRelatedReceipt?: ReceiptDTO;
    notVisibleRelatedReceipts?: Array<RelatedDocumentDTO>;
    visibleRelatedReceipts?: Array<RelatedDocumentDTO>;
    documentAssociationType?: String,
    contractModificationType?: string;
    activeTemporayPeriodOrganizationalChange?: boolean;
    enabledPreviousOrganizationalUnitRegistration?: boolean;
    selectedProjectOrganizationalSnapshot?: any;
  };
}

@Component({
  selector: 'settlement',
  //templateUrl: '../../baseFormComponent/baseForm.template.html'
  templateUrl: '../../../dossiers/registerContractModifications/registerContractModification.template.html',
  providers: [SettlementValidations, ProjectOrganizationalSnapshotValidations]
})
export class SettlementComponent extends BaseFormComponent<SettlementDTO, SettlementModel> implements OnInit, OnDestroy {
  private contract: ContractDTO;
  constructor(
    private settlementValidations: SettlementValidations,
    private projectOrganizationalSnapshotValidations: ProjectOrganizationalSnapshotValidations,
    elem: ElementRef) {
    super(elem);
  }

  ngOnInit(): void {
    if (this.task && this.task.work && this.task.work['settlement'] && this.task.work['settlement'].contract) {
      console.log('INVOCACION DE Settlement DESDE TAREA', this.task);
      this.contract = this.task.work['settlement'].contract;
    }
    super.ngOnInit();
  }

  getFormSettingURL(): string {
    return 'settlement/settlementSettings.json';
  }
  getServiceURL(): string {
    return undefined;
  }
  getObjectIdentifier() {
    return undefined;
  }


  dtoToModel(dto: SettlementDTO): Observable<SettlementModel> {
    let model = new SettlementModel();

    // TODO ver si WorkSettlement hay que incluirlo en plyca-dtos.ts
    model.dto = this.task.work['settlement'];

    model.ui = {
      edition: true,
      isModeError: false,
      isREPLYCATask: false,
      isProjectReplyca: false,
      isPossibleAssociateReceipt: false,
      existsRelatedReceipt: false,
      relatedDocument: new DocumentDTO(),
      originalRelatedReceipt: null,
      selectedRelatedReceipt: null,
      notVisibleRelatedReceipts: new Array<RelatedDocumentDTO>(),
      visibleRelatedReceipts: new Array<RelatedDocumentDTO>(),
      documentAssociationType: null,
      contractModificationType: null,
      activeTemporayPeriodOrganizationalChange: false,
      enabledPreviousOrganizationalUnitRegistration: false,
      selectedProjectOrganizationalSnapshot: new Object()
    };

    model.ui.contractModificationType = this.translate.instant('Settlement.detail.contractModificationType.value');
    if (this.task && this.task.work) {
      if (this.task.work.context && this.task.work.context.configurations) {
        if (this.task.work.context.configurations['screenMode']) {
          if (this.task.work.context.configurations['screenMode'].value == 'RECTIFICA' || this.task.work.context.configurations['screenMode'].value == 'ANULA') {
            model.ui.isModeError = true;
            if (this.task.work.context.configurations['screenMode'].value == 'ANULA') {
              model.ui.edition = false;
            }
          }
        }
        if (this.task.work.context.configurations['isREPLYCATask'].value == '1') {
          model.ui.isREPLYCATask = true;
        }
        if (this.task.work.context.configurations['documentAssociationType'].value) {
          model.ui.documentAssociationType = this.task.work.context.configurations['documentAssociationType'].value;
        }

        if (this.task.work.context.configurations['isProjectReplyca'].value == '1') {
          model.ui.isProjectReplyca = true;
        }
        if (this.task.work.context.configurations['isPossibleAssociateReceipt'] && this.task.work.context.configurations['isPossibleAssociateReceipt'].value == '1') {
          model.ui.isPossibleAssociateReceipt = true;
        }

      }

      model.ui.divisionId = getSimpleIdentifierFromString(model.dto.division.identifier);
      model.ui.dossierId = this.normalizaDossierId(getParentIdentifierFromString(model.dto.division.identifier));

      if (model.dto?.context && model.dto.context.configurations['activeTemporayPeriodOrganizationalChange']) {
        model.ui.activeTemporayPeriodOrganizationalChange = model.dto.context.configurations['activeTemporayPeriodOrganizationalChange'].value;
        if (model.ui.activeTemporayPeriodOrganizationalChange) {
          model.ui.enabledPreviousOrganizationalUnitRegistration = true;
        } else {
          if (model.dto.previousOrganizationalUnitRegistration !== undefined) {
            //No está activo, pero el campo se ha visualizado en algun monmento: subsanacion
            model.ui.enabledPreviousOrganizationalUnitRegistration = false;
          }
        }
      }

      model.ui.selectedProjectOrganizationalSnapshot = model.dto.projectOrganizationalSnapshot;

      if (model.dto.document && model.dto.document.relatedDocuments) {
        let relatedDocuments = model.dto.document.relatedDocuments;
        for (let i in relatedDocuments) {
          if (relatedDocuments[i]) {
            if (relatedDocuments[i].visible) {
              model.ui.visibleRelatedReceipts.push(relatedDocuments[i]);
            } else {
              model.ui.notVisibleRelatedReceipts.push(relatedDocuments[i]);
            }
          }
        }
      }

      if (model.ui.visibleRelatedReceipts
        && model.ui.visibleRelatedReceipts[0]
        && model.ui.visibleRelatedReceipts[0].document) {
        model.ui.relatedDocument = model.ui.visibleRelatedReceipts[0].document;
        //model.ui.existsRelatedReceipt = true;

        // Necesitamos recuperar la recepción asociada
        let filterParams: any;
        filterParams = {};
        let entity = model.ui.visibleRelatedReceipts[0].document.entity;
        filterParams.division = getSimpleIdentifierFromString(entity.division.identifier);
        filterParams.orderNumber = entity.orderNumber;
        filterParams.documentClassId = entity.documentClass.identifier;
        filterParams.dossierId = getParentIdentifierFromString(entity.division.identifier);


        this.subscribe(this.plycaService.query<ReceiptDTO>(
          this.configuration.RECEIP_SERVICE_URL,
          filterParams
        ), (resultReceipts: PaginationDTO<ReceiptDTO>) => {
          if (resultReceipts && resultReceipts.page && resultReceipts.page.totalElements == 1) {
            //originalRelatedReceipt es necesario para poder buscar la que ya estuviera asociada.
            // Se puede abrir una tarea con una recepción asociada, borrar y volver a buscarla!!
            model.ui.originalRelatedReceipt = resultReceipts.content[0];
            model.ui.selectedRelatedReceipt = resultReceipts.content[0];
            model.ui.existsRelatedReceipt = true;
            /*if (model.ui.originalRelatedReceipt && (this.model.dto.receiptDate === undefined || model.dto.receiptDate == null)) {
              this.model.dto.receiptDate = model.ui.originalRelatedReceipt.receiptDate;
            }*/
          }
        });
      }
    }



    return of(model);
  }

  normalizaDossierId(dossierId: string): string {
    return dossierId.substring(0, 4) + '/' + dossierId.substring(4);
  }

  modelToDTO(model: SettlementModel): SettlementDTO {
    if (model && model.dto && model.dto.document) {
      model.dto.document.relatedDocuments = [].concat(model.ui.notVisibleRelatedReceipts, model.ui.visibleRelatedReceipts);

      //Al snapshot de la liquidacion, le establecemos los datos del formulario
      /*if (model.ui.projectOrganizationalSnapshot && model.dto.projectOrganizationalSnapshot) {
        model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitName = model.ui.projectOrganizationalSnapshot.contractorOrganizationalUnitName;
        model.dto.projectOrganizationalSnapshot.contractorOrganizationalUnitHex = model.ui.projectOrganizationalSnapshot.contractorOrganizationalUnitHex;
        model.dto.projectOrganizationalSnapshot.fundsCenterDescription = model.ui.projectOrganizationalSnapshot.fundsCenterDescription;
        model.dto.projectOrganizationalSnapshot.fundsCenter = model.ui.projectOrganizationalSnapshot.fundsCenter;
        model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitName = model.ui.projectOrganizationalSnapshot.promoterOrganizationalUnitName;
        model.dto.projectOrganizationalSnapshot.promoterOrganizationalUnitHex = model.ui.projectOrganizationalSnapshot.promoterOrganizationalUnitHex;
        model.dto.projectOrganizationalSnapshot.contractorInboxName = model.ui.projectOrganizationalSnapshot.contractorInboxName;
        model.dto.projectOrganizationalSnapshot.contractorInboxId = model.ui.projectOrganizationalSnapshot.contractorInboxId;
      }*/

      // Mirar!! Para evitar problemas en la serializacion*/
      model.dto.document.relatedDocuments = JSON.parse(
        JSON.stringify(model.dto.document.relatedDocuments, (k, v) => (k === '_parent' ? undefined : v))
      );
    }
    return model.dto;
  }

  getHeaderInfo(): BaseFormHeaderInfo {
    let headerInfo = new BaseFormHeaderInfo();
    headerInfo.titleKey = 'Settlement.detail.title';
    headerInfo.titleIcon = 'fas fa-hand-holding';
    headerInfo.project = this.model.dto.division.project;
    return headerInfo;
  }

  ngOnDestroy(): void {
    this.headerActionsService.clearWindowActions(this.modalWindowHash);
    super.ngOnDestroy();
  }


  /*protected updateTask(updatedTask: TaskDTO) {
    this.formService.merge(this.task, updatedTask);
  }*/

  initHeaderActions() {
    this.formConfig.showValidations = true;
    this.headerActionsService.clearWindowActions(this.windowHash);
    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.accept',
        'fas fa-lg fa-check',
        'btn-primary',
        true,
        this.windowHash
      ),
      success => {
        let subscription = this.subscribe(this.processTaskObservable().pipe(
          finalize(() => {
            //this.processedTask = true;
            //this.load();
          })
        )
        );
        this.registerSubscription(subscription);


        /*this.processTask(), err => {
          console.log('No existe el atributo');
        };*/
        //this.confirmGeneralAccept();
      });
    this.headerActionsService.addDivider();
    this.addBackAction();
  }


  confirmGeneralAccept() {
    //let continue = false;
    let atribParams = 'PROPUESTAID=' + this.model.ui.dossierId;
    this.plycaService
      .getAttributeValue('CAMBIO_ORGANIZATIVO_ACTIVO',
        atribParams)
      .subscribe(result => {
        if (result && result.values && result.values.length > 0) {
          console.log("Atributo: " + result.values[0].columns['CAMBIO_ORGANIZATIVO_ACTIVO'].value);
          let attValue = result.values[0].columns['CAMBIO_ORGANIZATIVO_ACTIVO'].value;
          if (attValue === 'SI') {
            this.uiService.showConfirmMessage({
              message: 'Existen Contratos Basados para esta adjudicación de Acuerdo Marco que no están aún adjudicados. ¿Desea continuar?',
              header: 'Aviso',
              icon: 'pi pi-exclamation-triangle',
              accept: () => {
                this.processTask();
                console.log('SE ACEPTA');
              },
              reject: () => {
                console.log('NO SE ACEPTA');
              }
            });
          } else {
            this.processTask();
          }
        }
      },
        err => {
          console.log('No existe el atributo');
          this.processTask()
        });
  }


  configureFormConfig(formConfig: FormConfig): Observable<FormConfig> {

    this.loadFunctions(formConfig);
    return super.configureFormConfig(formConfig);
  }



  protected getTask(): TaskDTO {
    this.modelToDTO(this.model);
    this.task.work;
    return this.task;
  }


  //Funciones


  loadFunctions(_formConfig: FormConfig) {
    console.log('loadFunctions');
    _formConfig.functions.push({
      identifier: 'changeAssociatedReception',
      fn: this.changeAssociatedReception.bind(this)
    });
    _formConfig.functions.push({
      identifier: 'isVisibleRegisterData',
      fn: this.settlementValidations.isVisibleRegisterData
    });
    _formConfig.functions.push({
      identifier: 'loadOrganizationalSnapshotData',
      fn: this.projectOrganizationalSnapshotValidations.loadOrganizationalSnapshotData
    });
    _formConfig.functions.push({
      identifier: 'changeProjectOrganizationalSnapshot',
      fn: this.projectOrganizationalSnapshotValidations.changeProjectOrganizationalSnapshot
    });
    _formConfig.functions.push({
      identifier: 'visiblePreviousOrganizationalUnitRegistration',
      fn: this.projectOrganizationalSnapshotValidations.visiblePreviousOrganizationalUnitRegistration
    });

  }

  resetAssociatedReception(changes?: any) {
    let oldValue = new ReceiptDTO();
    oldValue = changes.oldValue;
    let newValue = new ReceiptDTO();
    newValue = changes.newValue;

    let reset = (oldValue == null && newValue != null) || (oldValue != null && newValue == null)
      || ((oldValue != null && newValue != null) && (oldValue.identifier != newValue.identifier));
    //console.log('======resetAssociatedReception', reset);
    return reset;
  }

  changeAssociatedReception(model: any, changes?: any) {
    //console.log('EJECUTADO changeAssociatedReception - Inicio', model, changes);
    if (this.model.ui.isProjectReplyca) {
      //console.log('EJECUTADO changeAssociatedReception - No hace nada', model, changes);
      return;
    }
    console.log('EJECUTADO changeAssociatedReception -  dowork', model, changes);
    let reset = this.resetAssociatedReception(changes);

    if (reset) {
      let newValue = new ReceiptDTO();
      newValue = changes.newValue;

      if (this.model.ui.selectedRelatedReceipt === undefined) {
        model.ui.selectedRelatedReceipt = null;
        model.dto.receiptDate = null;
      } else {
        model.ui.selectedRelatedReceipt = newValue;
        model.dto.receiptDate = model.ui.selectedRelatedReceipt.receiptDate;
      }



      // - PLA.AYMAD-4027 - Ficha de Liquidación: no graba la asociación entre liquidaciones y recepciones.
      // - receiptDTO
      // -- Document
      // --- Entity
      // A pesar de que el buscador calcula el entity, la arquitectura después lo borra por estar esa información en el propio DTO (receiptDTO)

      this.model.ui.visibleRelatedReceipts = new Array<RelatedDocumentDTO>();

      if (newValue && newValue.document && newValue.document.identifier) {
        let relatedReceipt = new RelatedDocumentDTO();
        relatedReceipt.document = newValue.document;
        relatedReceipt.document.entity.documentClass = newValue.documentClass
        relatedReceipt.document.entity.division = newValue.division;
        relatedReceipt.document.entity.orderNumber = newValue.orderNumber;
        relatedReceipt.readOnly = false;
        relatedReceipt.visible = true;


        relatedReceipt.relation = <MasterDataDTO>{
          identifier: this.model.ui.documentAssociationType
        };
        this.model.ui.visibleRelatedReceipts.push(relatedReceipt);
      }
    }
  }
}